import buttonFormFields from '@/components/sections/form-fields/content/button'
import sectionFormFields from '@/components/sections/form-fields/design/section'
import structureFormFields from '@/components/sections/form-fields/layout/structure'
import contentBoxFormFields from '@/components/sections/form-fields/layout/content-box'

export const content = {
  title: {
    label: 'Title',
    type: 'text',
    category: 'Content'
  },
  introtext: {
    label: 'Introtext',
    type: 'text-editor',
    category: 'Content'
  },
  buttons: {
    label: 'Buttons',
    type: 'repeatable',
    fields: buttonFormFields,
    category: 'Content'
  },

  'map-latitude': {
    label: 'Map latitude',
    type: 'text',
    rules: ['required'],
    category: 'Map'
  },
  'map-longitude': {
    label: 'Map longitude',
    type: 'text',
    rules: ['required'],
    category: 'Map'
  },
  'map-zoom': {
    label: 'Map zoom',
    type: 'slider',
    min: 1,
    max: 25,
    suffix: '',
    default: '15',
    category: 'Map'
  }
}

export const design = {
  ...sectionFormFields,
  'title-color': {
    label: 'Title color',
    type: 'text-color',
    category: 'Text'
  },
  'title-font-weight': {
    label: 'Title font weight',
    type: 'radio',
    options: [
      { value: 'var(--title-font-weight)', text: 'Default' },
      { value: 'lighter', text: 'Light' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Text'
  },
  'title-tag': {
    label: 'Title header type',
    type: 'radio',
    options: [
      { value: 'h1', text: 'Heading 1' },
      { value: 'h2', text: 'Heading 2' },
      { value: 'h3', text: 'Heading 3' },
      { value: 'h4', text: 'Heading 4' },
      { value: 'h5', text: 'Heading 5' },
      { value: 'h6', text: 'Heading 6' }
    ],
    category: 'Text'
  },
  'introtext-color': {
    label: 'Introtext color',
    type: 'text-color',
    category: 'Text'
  }
}

export const layout = {
  ...structureFormFields,
  'content-vertical-alignment': {
    label: 'Content vertical alignment',
    type: 'radio',
    options: [
      { value: 'start', text: 'Top' },
      { value: 'center', text: 'Center' },
      { value: 'end', text: 'Bottom' }
    ],
    category: 'Structure'
  },
  'map-height': {
    label: 'Map height',
    type: 'slider',
    min: 300,
    max: 600,
    step: 10,
    suffix: '',
    default: '450',
    category: 'Map'
  },
  'map-size': {
    label: 'Map size',
    type: 'radio',
    options: [
      { value: 'sm', text: 'Small' },
      { value: 'md', text: 'Medium' },
      { value: 'lg', text: 'Large' }
    ],
    category: 'Map'
  },
  'map-position': {
    label: 'Map position',
    type: 'radio',
    options: [
      { value: 'left', text: 'Left' },
      { value: 'right', text: 'Right' }
    ],
    category: 'Map'
  },
  ...contentBoxFormFields
}

export const advanced = {}

export default {
  content,
  design,
  layout,
  advanced
}
